import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTools, FaArrowLeft } from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './PlaceholderPage.css';

const PlaceholderPage = ({ title, subtitle }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title={`${title} — ATAA REALTY`}
        description={`${title} — ${subtitle}. Section en cours de préparation chez ATAA REALTY.`}
        noindex
      />
      <Navbar />

      <header className="placeholder-header">
        <div className="placeholder-overlay"></div>
        <div className="container placeholder-title-box anim-up">
          <span className="placeholder-subtitle">{subtitle}</span>
          <h1>{title}</h1>
        </div>
      </header>

      <section className="placeholder-content-section">
        <div className="container">
          <div className="placeholder-card anim-up">
            <div className="placeholder-icon"><FaTools /></div>
            <h2>Page en construction</h2>
            <p>
              Cette section du site <strong>ATAA REALTY</strong> est en cours de
              préparation. Nos équipes y travaillent activement afin de vous
              proposer un contenu à la hauteur de nos exigences.
            </p>
            <p className="placeholder-hint">
              En attendant, n'hésitez pas à nous contacter directement pour toute
              demande spécifique.
            </p>
            <Link to="/" className="placeholder-back-btn">
              <FaArrowLeft /> Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PlaceholderPage;
